import { render, staticRenderFns } from "./SecondhandListItem.vue?vue&type=template&id=09058627&scoped=true&lang=pug"
import script from "./SecondhandListItem.vue?vue&type=script&lang=ts"
export * from "./SecondhandListItem.vue?vue&type=script&lang=ts"
import style0 from "./SecondhandListItem.vue?vue&type=style&index=0&id=09058627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09058627",
  null
  
)

export default component.exports